import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Fase } from '../../../models/fase';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/combineLatest';
import 'rxjs/add/operator/switchMap';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { FaseService } from '../fase.service';

@Component({
  templateUrl: './visualizar-fase.component.html',
})
export class VisualizarFaseComponent extends WebPage implements OnInit {

  imprime;
  fase;
  somaVagas = 0;
  somaVagasCidade = 0;

  constructor(private route: ActivatedRoute, private router: Router, private faseService: FaseService, messageService: MessageService) {
    super(messageService);
  }

  ngOnInit() {
    this.isLoading = true;
    Observable.combineLatest(
      this.route.paramMap,
      this.route.queryParamMap
    )
    .switchMap(combined => {
      const idFase = combined[0].get('idFase');
      this.imprime = combined[1].get('imprimir');
      return this.faseService.getFull(idFase);
    })
    .finally(() => this.isLoading = false)
    .subscribe(
      fase => {
        this.fase = fase;
        this.fase.faseUnidades.forEach(faseUnidade => {
          this.somaVagas = +this.somaVagas + +faseUnidade.nroVagas;
        });
        this.fase.faseUnidadeMunicipios.forEach(faseUnidadeMunicipio => {
          this.somaVagasCidade = +this.somaVagasCidade + +faseUnidadeMunicipio.numVagas;
        });
        if (this.imprime) {
          setTimeout(() => {
            this.imprimir();
            this.router.navigate(['/gerenciar-fase']);
          }, 1);
        }
      },
      error => this.gerenciaErro(error)
    );
  }

  imprimir() {
    let printContents, popupWin;
    printContents = document.getElementById('print-section').innerHTML;
    popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    popupWin.document.open();
    popupWin.document.write(`
      <html>
        <head>
          <title>Emprego na Pista</title>
          <link href='//fonts.googleapis.com/css?family=Open+Sans:300,400,600' rel='stylesheet' type='text/css'/>
          <link rel="stylesheet" type="text/css" href="https://framework.sestsenat.org.br/versao/3.2/css/framework-sest-senat.css">
          <link rel="stylesheet" type="text/css" href="https://framework.sestsenat.org.br/versao/3.2/css/docs.css"/>
        </head>
        <body onload="window.print();window.close()">
          <h4>Emprego na Pista</h4>
          ${printContents}
        </body>
      </html>
    `);
    popupWin.document.close();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/fase/visualizar/visualizar-fase.component.ts